import React from 'react';
import { IconProps } from './type';

export const ICWorkOrder: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="28" y="20" width="72" height="92" rx="14" fill="#4f4b5c" />
            <rect x="46" y="12" width="36" height="20" rx="8" fill="#a797ff" />
            <rect x="42" y="46" width="44" height="8" rx="4" fill="#E8C97A" />
            <rect x="42" y="64" width="34" height="6" rx="3" fill="#E8C97A" />
            <rect x="42" y="78" width="26" height="6" rx="3" fill="#E8C97A" />
            <path
                d="M82 76L98 92"
                stroke="#a797ff"
                strokeWidth={7}
                strokeLinecap="round"
            />
            <path
                d="M98 78C94 77 90 78 87 81C84 84 83 88 84 92L74 102L66 94L76 84C80 85 84 84 87 81C90 78 91 74 90 70L98 78Z"
                fill="#a797ff"
            />
        </svg>
    );
};
